/**
 * https://ietf.org/assignments/oauth-parameters/oauth-parameters.xml
 */
export enum GrantType {
  PASSWORD = 'password',
  CLIENT_CREDENTIALS = 'client_credentials',
  AUTHORIZATION_CODE = 'authorization_code',
  REFRESH_TOKEN = 'refresh_token',
  URN_JWT_BEARER_GRANT = 'urn:ietf:params:oauth:grant-type:jwt-bearer',
  URN_JWT_BEARER_PROFILE = 'urn:ietf:params:oauth:client-assertion-type:jwt-bearer',
  URN_SAML2_BEARER_GRANT = 'urn:ietf:params:oauth:grant-type:saml2-bearer',
  URN_SAML2_BEARER_PROFILE = 'urn:ietf:params:oauth:client-assertion-type:saml2-bearer',
  URN_JWT_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:jwt',
  URN_DEVICE_FLOW = 'urn:ietf:params:oauth:grant-type:device_code',
  URN_TOKEN_EXCHANGE = 'urn:ietf:params:oauth:grant-type:token-exchange',
  URN_ACCESS_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:access_token',
  URN_REFRESH_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:refresh_token',
  URN_ID_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:id_token',
  URN_SAML1_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:saml1',
  URN_SAML2_TOKEN_TYPE = 'urn:ietf:params:oauth:token-type:saml2',
}